// extracted by mini-css-extract-plugin
module.exports = {"title":"testRevenue-title-1LR_sE","content":"testRevenue-content-tqeZP2","revenueAccordionFaq":"testRevenue-revenueAccordionFaq-3XcAFw"};